var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: ['grid', ("grid_" + (_vm.count) + "-count"), ("grid_" + (_vm.largeCount) + "-large")]
  }, _vm._l(_vm.list, function (category, index) {
    return _c('div', {
      key: index,
      staticClass: "grid__item"
    }, [_c('a', {
      staticClass: "category",
      class: [{
        category_big: _vm.largeCount > index
      }],
      style: {
        backgroundColor: category.backgroundColor
      },
      attrs: {
        "href": _vm.darkstoreUrl + category.path
      },
      on: {
        "click": function ($event) {
          return _vm.$emit('category-click', category);
        }
      }
    }, [_c('div', {
      staticClass: "category__text-wrap"
    }, [_c('div', {
      staticClass: "category__title"
    }, [_vm._v("\n          " + _vm._s(category.name) + "\n        ")])]), _vm._v(" "), _c('div', {
      staticClass: "category__img-wrap"
    }, [_c('div', {
      class: ['category__img-link', {
        'category__img-link_high': _vm.count === 4 && index === 1 || _vm.count === 3 && index === 1,
        'category__img-link_long': _vm.count === 4 && index === 2 || _vm.count === 5 && index === 3,
        'category__img-link_max-long': _vm.count === 3 && index === 2
      }]
    }, [category.image ? _c('img', {
      ref: "img",
      refInFor: true,
      staticClass: "category__img",
      attrs: {
        "src": category.image.original,
        "alt": category.name
      }
    }) : _vm._e()])])])]);
  }), 0);
}
var staticRenderFns = []

export { render, staticRenderFns }